import { cache, CACHE_CONFIG } from '../utils/cacheUtils';
import Modal from './Modal';

export default function CacheManager({ open, onClose }) {
  const stats = cache.getStats();

  const clearAll = () => {
    cache.clearAll();
    onClose();
    window.location.reload();
  };

  const clearCache = (name) => {
    cache.clear(CACHE_CONFIG[name]);
  };

  return (
    <Modal open={open} onClose={onClose} large>
      <h3 style={{ fontFamily: 'Syne', marginBottom: '0.5rem' }}>Cache Manager</h3>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: '1rem' }}>
        Manage locally cached data for faster loading.
      </p>

      {stats ? (
        <div className="cache-stats">
          <div className="cache-stat-row">
            <span>Total entries</span>
            <span>{stats.totalEntries}</span>
          </div>
          <div className="cache-stat-row">
            <span>Total size</span>
            <span>{(stats.totalSize / 1024).toFixed(1)} KB</span>
          </div>
          {Object.entries(stats.caches).map(([name, info]) => (
            <div key={name} className="cache-stat-row">
              <span>{name}</span>
              <span className={info.stale ? 'stale' : 'fresh'}>
                {(info.size / 1024).toFixed(1)} KB · {info.stale ? 'stale' : 'fresh'}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-state">No cached data</p>
      )}

      <div className="form-actions">
        {Object.keys(CACHE_CONFIG).map((name) => (
          <button key={name} className="btn btn-ghost btn-sm" onClick={() => clearCache(name)}>
            Clear {name}
          </button>
        ))}
        <button className="btn btn-danger btn-sm" onClick={clearAll}>Clear All</button>
      </div>
    </Modal>
  );
}
